// Mobile Image Slider for Product Pages
function getZoomAdjustedViewportWidth() {
    if (typeof window === 'undefined') {
        return 0;
    }

    const viewport = window.visualViewport;
    if (viewport && typeof viewport.width === 'number' && viewport.width > 0) {
        return Math.round(viewport.width);
    }

    const doc = document.documentElement;
    return window.innerWidth || (doc && doc.clientWidth) || 0;
}

class MobileImageSlider {
    constructor() {
        this.slider = document.querySelector('.mobile-slider');
        this.prevButton = document.querySelector('.mobile-image-slider .slider-button--prev');
        this.nextButton = document.querySelector('.mobile-image-slider .slider-button--next');
        this.counterNumbers = document.querySelectorAll('.mobile-image-slider .slider-counter__number');

        if (!this.slider || !this.prevButton || !this.nextButton || this.counterNumbers.length === 0) {
            return; // Elements not found, exit early
        }

        this.slides = this.slider.querySelectorAll('.mobile-slide');
        this.totalSlides = this.slides.length;
        this.currentSlide = 0;
        this.isScrolling = false;
        this.boundHandleResize = this.handleResize.bind(this);

        this.init();
    }

    init() {
        if (this.totalSlides <= 1) {
            return;
        }

        this.bindEvents();
        this.updateSliderPosition(false);
    }

    handleResize() {
        this.updateSliderPosition(false);
    }

    bindEvents() {
        window.addEventListener('resize', this.boundHandleResize, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.boundHandleResize, { passive: true });
        }

        this.nextButton.addEventListener('click', () => this.goToNextSlide());
        this.prevButton.addEventListener('click', () => this.goToPrevSlide());

        this.counterNumbers.forEach((number, index) => {
            number.addEventListener('click', () => this.goToSlide(index));
        });

        // Touch/swipe support
        let startX = 0;
        let startY = 0;
        let scrollLeft = 0;
        let slideBeforeSwipe = 0;

        this.slider.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            scrollLeft = this.slider.scrollLeft;
            slideBeforeSwipe = this.currentSlide;
            this.isScrolling = true;
        });

        this.slider.addEventListener('touchmove', (e) => {
            if (!this.isScrolling) return;

            const currentX = e.touches[0].clientX;
            const currentY = e.touches[0].clientY;
            const diffX = Math.abs(startX - currentX);
            const diffY = Math.abs(startY - currentY);

            if (diffX > diffY && diffX > 10) {
                e.preventDefault();
                const scrollDiffX = startX - currentX;
                this.slider.scrollLeft = scrollLeft + scrollDiffX;
            }
        });

        this.slider.addEventListener('touchend', (e) => {
            if (!this.isScrolling) return;
            this.isScrolling = false;

            const endX = e.changedTouches[0].clientX;
            const diffX = startX - endX;
            const threshold = 50;

            if (Math.abs(diffX) > threshold) {
                this.currentSlide = slideBeforeSwipe;
                if (diffX > 0) {
                    this.goToNextSlide();
                } else {
                    this.goToPrevSlide();
                }
            } else {
                this.currentSlide = slideBeforeSwipe;
                this.updateSliderPosition();
            }
        });

        // Handle scroll events to update counter
        this.slider.addEventListener('scroll', () => {
            const slideWidth = this.slider.offsetWidth;
            const scrolled = this.slider.scrollLeft;
            const newSlide = Math.round(scrolled / slideWidth);

            if (newSlide !== this.currentSlide && newSlide >= 0 && newSlide < this.totalSlides) {
                this.currentSlide = newSlide;
                this.updateCounter(this.currentSlide + 1);
                this.updateButtonStates();
            }
        });
    }

    updateSliderPosition(smooth = true) {
        const slideWidth = this.slider.offsetWidth;
        this.slider.scrollTo({
            left: this.currentSlide * slideWidth,
            behavior: smooth ? 'smooth' : 'instant'
        });

        this.updateCounter(this.currentSlide + 1);
        this.updateButtonStates();
    }

    updateButtonStates() {
        // Disable prev on first slide, disable next on last slide
        this.prevButton.disabled = (this.currentSlide === 0);
        this.nextButton.disabled = (this.currentSlide === this.totalSlides - 1);

        this.prevButton.style.opacity = this.currentSlide === 0 ? '0.3' : '1';
        this.nextButton.style.opacity = this.currentSlide === this.totalSlides - 1 ? '0.3' : '1';
    }

    updateCounter(currentSlideNumber) {
        this.counterNumbers.forEach(number => {
            number.classList.remove('active');
        });

        if (this.counterNumbers[currentSlideNumber - 1]) {
            this.counterNumbers[currentSlideNumber - 1].classList.add('active');
        }
    }

    goToNextSlide() {
        if (this.currentSlide < this.totalSlides - 1) {
            this.currentSlide++;
            this.updateSliderPosition();
        }
    }

    goToPrevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            this.updateSliderPosition();
        }
    }

    goToSlide(slideIndex) {
        if (slideIndex >= 0 && slideIndex < this.totalSlides) {
            this.currentSlide = slideIndex;
            this.updateSliderPosition();
        }
    }

    destroy() {
        window.removeEventListener('resize', this.boundHandleResize);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.boundHandleResize);
        }
    }
}

// Initialize when DOM is loaded and handle responsive initialization
(function () {
    let mobileSliderInstance = null;
    let resizeTimeout = null;
    let lastKnownViewportState = null;
    const MOBILE_BREAKPOINT = 990;

    function isMobileViewport() {
        return getZoomAdjustedViewportWidth() <= MOBILE_BREAKPOINT;
    }

    function initSlider() {
        if (isMobileViewport() && !mobileSliderInstance) {
            mobileSliderInstance = new MobileImageSlider();
            lastKnownViewportState = 'mobile';
        }
    }

    function destroySlider() {
        if (!isMobileViewport() && mobileSliderInstance) {
            if (typeof mobileSliderInstance.destroy === 'function') {
                mobileSliderInstance.destroy();
            }
            mobileSliderInstance = null;
            lastKnownViewportState = 'desktop';
        }
    }

    function handleResize() {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(() => {
            const isMobile = isMobileViewport();
            const currentState = isMobile ? 'mobile' : 'desktop';

            // Only destroy/init if viewport state actually changed
            if (currentState !== lastKnownViewportState) {
                if (isMobile) {
                    initSlider();
                } else {
                    destroySlider();
                }
            } else if (mobileSliderInstance && typeof mobileSliderInstance.handleResize === 'function') {
                // Just update positions on zoom
                mobileSliderInstance.handleResize();
            }
        }, 250);
    }

    document.addEventListener('DOMContentLoaded', () => {
        initSlider();
        window.addEventListener('resize', handleResize, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', handleResize, { passive: true });
        }
    });
})();